export default __webpack_public_path__ + "static/media/appraise3.226fa74d.png";